import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export default function ArchivePosUserDialog(props) {
    const { posUser, onDelete, onCancel } = props;
    
    return (
        <Dialog closeIcon={false} width={350} title={"Archive POS User"}>
            {
                <p style={{ margin: "25px", textAlign: "center", fontSize: 14 }}>
                    Are you sure you want to archive the POS user {posUser.name} with username "{posUser.username}"?
                </p>
            }
            
            {(
                <DialogActionsBar>
                    <button onClick={() => onDelete(posUser)} className="k-button k-button-primary" aria-label="yes button of archive dialog" style={{fontSize: 12}}>
                        Yes
                    </button>
                    <button onClick={onCancel} className="k-button" aria-label="no button of archive dialog" style={{fontSize: 12}}>
                        No
                    </button>
                </DialogActionsBar>
            )}
        </Dialog>
    );
}